const MAX_ENTRIES = 2000
const entries = []

function log (ev) {
    entries.push({ receivedAt: new Date().toISOString(), ev })
    if (entries.length > MAX_ENTRIES) entries.shift()
}

function download (filename) {
    const name = filename || `ws-log-${new Date().toISOString().replace(/[:.]/g, '-')}.jsonl`
    const body = entries.map(e => JSON.stringify(e)).join('\n') + '\n'
    const blob = new Blob([body], { type: 'text/plain' })
    const url = URL.createObjectURL(blob)
    const a = document.createElement('a')
    a.href = url
    a.download = name
    document.body.appendChild(a)
    a.click()
    document.body.removeChild(a)
    URL.revokeObjectURL(url)
    return name
}

function clear () {
    entries.length = 0
}

function count () {
    return entries.length
}

function filter (fn) {
    return entries.filter(fn)
}

function byMethod (method) {
    return entries.filter(e => e.ev && e.ev.action && e.ev.action.method === method)
}

export default { log, download, clear, count, filter, byMethod, entries }
